import { type EventStandardDefs } from '@solinkcorp/event-standard';
import { getReduxStore } from 'stores/store';
import { i18nEventFieldName } from 'utils/EventUtil';
import LocaleUtil from 'utils/LocaleUtil';
import { FixedWidthFieldRenderer } from './base';
import { type FieldValue } from './types';

export class BooleanFieldRenderer extends FixedWidthFieldRenderer {
  static makeTemplateContextStatic(
    eventStandard: EventStandardDefs,
    fieldName: string,
    fieldValue: FieldValue | FieldValue[],
  ): { fieldName: string; fieldValue: string | string[] } {
    const locale = LocaleUtil.getLocale(getReduxStore().getState().localeState.localeCode);
    if (Array.isArray(fieldValue)) {
      return {
        fieldName: i18nEventFieldName(fieldName, false, eventStandard),
        fieldValue: fieldValue.map((v) => (v ? locale.general.yes : locale.general.no)),
      };
    }

    return {
      fieldName: i18nEventFieldName(fieldName, false, eventStandard),
      fieldValue: fieldValue ? locale.general.yes : locale.general.no,
    };
  }
}
